/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const NotifyEntityCreatePage = lazyLoad(
  () => import('./index'),
  module => module.NotifyEntityCreatePage
);
